export const profileRebindPageStyles = {
  introCard: {
    borderRadius: 24,
    padding: 18,
    background: 'linear-gradient(145deg, #1d6fff 0%, #4f8dff 58%, #82b3ff 100%)',
    color: '#ffffff',
    boxShadow: '0 22px 46px rgba(23, 105, 255, 0.22)',
  } as const,
  introTitle: {
    fontSize: 20,
    fontWeight: 800,
    lineHeight: 1.2,
  } as const,
  introText: {
    marginTop: 8,
    fontSize: 13,
    lineHeight: 1.7,
    color: 'rgba(255, 255, 255, 0.84)',
  } as const,
  formCard: {
    borderRadius: 24,
    padding: 16,
    background: 'rgba(255, 255, 255, 0.92)',
    border: '1px solid rgba(255, 255, 255, 0.84)',
    boxShadow: '0 18px 38px rgba(76, 93, 135, 0.08)',
  } as const,
  currentPhoneCard: {
    marginTop: 14,
    borderRadius: 18,
    padding: '14px 14px 13px',
    background: 'linear-gradient(180deg, rgba(246, 249, 255, 0.98) 0%, rgba(239, 243, 252, 0.92) 100%)',
    border: '1px solid rgba(23, 105, 255, 0.08)',
  } as const,
  inputShell: {
    borderRadius: 16,
    background: '#f7f9fd',
    border: '1px solid rgba(23, 105, 255, 0.08)',
    padding: '0 14px',
  } as const,
  input: {
    '--font-size': '16px',
    '--placeholder-color': '#9aa3b8',
    minHeight: '48px',
  } as const,
  hintCard: {
    marginTop: 14,
    borderRadius: 18,
    padding: 14,
    background: 'rgba(23, 105, 255, 0.05)',
    border: '1px solid rgba(23, 105, 255, 0.08)',
  } as const,
  submitButton: {
    height: 48,
    borderRadius: 16,
    fontWeight: 700,
    boxShadow: '0 14px 30px rgba(23, 105, 255, 0.18)',
  } as const,
} as const;
